import React, { useState } from 'react';
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import NotificationTypesTab from './NotificationTypesTab';
import ApiKeysTab from './ApiKeysTab';
import LogsTab from './LogsTab';

const CustomPushPage: React.FC = () => {
  const { hasRole } = useAuth();
  const isAdmin = hasRole(['custom-push:admin']);
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, width: '100%' }}>
      <Typography variant="h5" sx={{ fontWeight: 500, color: 'text.secondary', mb: 3 }}>
        Custom Push Notifications
      </Typography>

      <Paper sx={{ borderRadius: 2, mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          {isAdmin && <Tab label="Notification Types" />}
          {isAdmin && <Tab label="API Keys" />}
          <Tab label="Logs" />
        </Tabs>
      </Paper>

      {isAdmin && tabValue === 0 && <NotificationTypesTab canManage={isAdmin} />}
      {isAdmin && tabValue === 1 && <ApiKeysTab />}
      {tabValue === (isAdmin ? 2 : 0) && <LogsTab />}
    </Box>
  );
};

export default CustomPushPage;
